import styled, { keyframes } from 'styled-components';

export const StyledLazyLoaderWrapper = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 997;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const animationNameHere = keyframes`
  0% { opacity: 1; }
  30% { opacity: 0.75; }
  50% { opacity: 0.5; }
  100% { opacity: 0.25; }
`;

const bouncingLoader = keyframes`
  from {
    width: 0.1rem; 
    height: 0.1rem;
    opacity: 1;
    transform: translate3d(0);
  }
  to {
    width: 1rem;
    height: 1rem;
    opacity: 0.1;
    transform: translate3d(0, -1rem, 0);
  }
`;

export const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoaderItem = styled.div`
  background: #fad000;
  border-radius: 50%;
  margin: 5rem 0.5rem;
  animation: ${bouncingLoader} 0.6s infinite alternate;

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }
`;
